import * as $ from 'jquery'

$(document).ready(function () {
    // 
    $('#demo').click(function () {
        $('#expand-panel').addClass('col-md-12');
        $('#right-panel').hide();
        $('#profile-collapse-back').show();
    });
    $('#profile-collapse-back').click(function () {
        $('#expand-panel').removeClass('col-md-12');
        $('#right-panel').show();
        $(this).hide();

    });
    $('#performance-tab-content, #leave-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
    $('#profile-tab').click(function () {
        $('#performance-tab-content, #leave-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
        $('#profile-tab-content').show();
        $('#performance-tab, #leave-tab, #touchbase-tab, #feedbacks-tab, #salaryrevision-tab, #onboarding-tab, #offboarding-tab').removeClass('active');
        $('#profile-tab').addClass('active');
    });

    $('#performance-tab').click(function () {
        $('#profile-tab-content, #leave-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
        $('#performance-tab-content').show();
        $('#leave-tab, #profile-tab, #touchbase-tab, #feedbacks-tab, #salaryrevision-tab, #onboarding-tab, #offboarding-tab').removeClass('active');
        $('#performance-tab').addClass('active');
    });

    $('#leave-tab').click(function () {
        $('#profile-tab-content, #performance-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
        $('#leave-tab-content').show();
        $('#performance-tab, #profile-tab, #touchbase-tab, #feedbacks-tab, #salaryrevision-tab, #onboarding-tab, #offboarding-tab').removeClass('active');
        $('#leave-tab').addClass('active');
    });

    $('#touchbase-tab').click(function () {
        $('#profile-tab-content, #performance-tab-content, #leave-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
        $('#touchbase-tab-content').show();
        $('#performance-tab, #profile-tab, #leave-tab, #feedbacks-tab, #salaryrevision-tab, #onboarding-tab, #offboarding-tab').removeClass('active');
        $('#touchbase-tab').addClass('active');
    });

    $('#feedbacks-tab').click(function () {
        $('#profile-tab-content, #performance-tab-content, #leave-tab-content, #touchbase-tab-content, #salaryrevision-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
        $('#feedbacks-tab-content').show();
        $('#performance-tab, #profile-tab, #leave-tab, #touchbase-tab, #salaryrevision-tab, #onboarding-tab, #offboarding-tab').removeClass('active');
        $('#feedbacks-tab').addClass('active');

    });

    $('#salaryrevision-tab').click(function () {
        $('#profile-tab-content, #performance-tab-content, #leave-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #onboarding-tab-content, #offboarding-tab-content').hide();
        $('#salaryrevision-tab-content').show();
        $('#performance-tab, #profile-tab, #leave-tab, #touchbase-tab, #feedbacks-tab, #onboarding-tab, #offboarding-tab').removeClass('active');
        $('#salaryrevision-tab').addClass('active');

    });

    $('#onboarding-tab').click(function () {
        $('#profile-tab-content, #performance-tab-content, #leave-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content,#offboarding-tab-content').hide();
        $('#onboarding-tab-content').show();
        $('#performance-tab, #profile-tab, #leave-tab, #touchbase-tab, #feedbacks-tab, #salaryrevision-tab, #offboarding-tab').removeClass('active');
        $('#onboarding-tab').addClass('active');

    });

    $('#offboarding-tab').click(function () {
        $('#profile-tab-content, #performance-tab-content, #leave-tab-content, #touchbase-tab-content, #feedbacks-tab-content, #salaryrevision-tab-content, #onboarding-tab-content').hide();
        $('#offboarding-tab-content').show();
        $('#performance-tab, #profile-tab, #leave-tab, #touchbase-tab, #feedbacks-tab, #salaryrevision-tab, #onboarding-tab').removeClass('active');
        $('#offboarding-tab').addClass('active');

    });



});

// var tooltipTriggerList = [].slice.call(
//     document.querySelectorAll('[data-bs-toggle="tooltip"]')
// );
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//     return new bootstrap.Tooltip(tooltipTriggerEl);
// });

